import Environment from "../environment";

import Api from './ApiService';

import Pago from "../models/Pago";


export const PagoService = {
    pagoManual: (data, id) => {
        return new Promise((resolve, reject) => {
                return Api.fetch(`${Environment.api}api/unidades-facturaciones/${id}/pagos`, 'POST', data
            ).then(data => {
                resolve(new Pago(data));
            }).catch((error) => {
                reject(error);
            }
            );
        });
    },
    pago360: (data, id) => {
        return new Promise((resolve, reject) => {
                return Api.fetch(`${Environment.api}api/unidades-facturaciones/${id}/pagos_360`, 'POST', data
            ).then(data => {
                resolve(new Pago(data));
            }).catch((error) => {
                reject(error);
            }
            );
        });
    },
    pagoExitoso: (id, external_reference) => {
        return new Promise((resolve, reject) => {
            return Api.fetch(`${Environment.api}api/unidades-facturaciones/${id}/pagos_360/pago_exitoso/${external_reference}`, 'POST'
            ).then(data => {
                resolve(new Pago(data));
            }).catch((error) => {
                reject(error);
            }
            );
        });
    },
    pagoRechazado: (id, external_reference) => {
        return new Promise((resolve, reject) => {
            return Api.fetch(`${Environment.api}api/unidades-facturaciones/${id}/pagos_360/pago_rechazado/${external_reference}`, 'POST'
            ).then(data => {
                resolve(new Pago(data));
            }).catch((error) => {
                reject(error);
            }
            );
        });
    },
    pagoPendiente: (id, external_reference) => {
        return new Promise((resolve, reject) => {
            return Api.fetch(`${Environment.api}api/unidades-facturaciones/${id}/pagos_360/pago_pendiente/${external_reference}`, 'POST'
            ).then(data => {
                resolve(new Pago(data));
            }).catch((error) => {
                reject(error);
            }
            );
        });
    },
}
